export default "__VITE_ASSET__44s_7ZnP__"